import { Component, OnInit } from '@angular/core';
import { ApiServiceService } from '../../services/common/api-service.service';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss']
})
export class BookingDetailsComponent implements OnInit {

  bookings: any[] = [];

  showServiceDetails: boolean = false;

  selectedBooking: any = null;


  constructor(
    private apiService: ApiServiceService,
    private router: Router,
    private location:Location
  ) {}


  ngOnInit(): void {

    const token = localStorage.getItem('sessionToken');

    let email: string | null = null;

    if (token) {

      try {

        const payload = JSON.parse(
          atob(token.split('.')[1])
        );

        email = payload.email;

      } catch (error) {

        console.error(
          'Invalid session token',
          error
        );

      }

    }


    console.log(
      'EMAIL SENT:',
      email
    );


    if (!email) {
      return;
    }


    this.apiService
      .getUserBookings(email)
      .subscribe({

        next: (res: any) => {

          console.log(
            'USER BOOKINGS',
            res
          );

          this.bookings =
            res.data || [];

        },

        error: (err: any) => {

          console.error(
            'USER BOOKINGS ERROR:',
            err
          );

          this.bookings = [];

        }

      });

  }
  goBack(): void {
  this.location.back();
}


  // ==========================================
  // SERVICE DETAILS POPUP
  // ==========================================

  openServiceDetails(
    booking: any
  ): void {

    console.log(
      'SELECTED BOOKING:',
      booking
    );

    console.log(
      'SERVICE:',
      booking?.serviceId
    );

    this.selectedBooking =
      booking;

    this.showServiceDetails =
      true;

  }



  closeServiceDetails(): void {

    this.showServiceDetails =
      false;

    this.selectedBooking =
      null;

  }



  goToPayments(): void {

    this.router.navigate([
      '/wedding-services/payment-details'
    ]);

  }

}